// extracted by css-extract-rspack-plugin
export default {"opacity50":"AddVacanciesModalTableRow-module__opacity50--mP9l9"};